import { buildThemeAliases } from "src/legacy/utils"
import { base } from "./base"

export const inputAliases = buildThemeAliases(base, {
  inline: "none",
  primary: "2SolidNavy",
})

export type InputAliases = Record<keyof typeof inputAliases, string>
